import { call, put, takeEvery } from 'redux-saga/effects';
import { PURCHASE_HISTORY_BY_RANGE_REQUEST, purchaseHistoryByRangeSuccess, purchaseHistoryByRangeFailure, purchaseHistoryList } from '../actions/actions';
import api from '../common/api';
import checkResponse from '../common/checkResponse';

function* handleRequest(action) {

  try {
    const response = yield call(api, action);
    const payload = yield response.json();

    if(!checkResponse(response, payload)) return;

    if( payload.sxp === false && payload.errMsg == null ) {
      yield put(purchaseHistoryList(payload));
      yield put(purchaseHistoryByRangeSuccess(payload));
    } else {
      yield put(purchaseHistoryByRangeFailure(payload));
    }
  } catch(error) {
    console.log("error ==> ",error);
  }
}

const purchaseHistoryByRangeSaga = [takeEvery(PURCHASE_HISTORY_BY_RANGE_REQUEST, handleRequest)];
export default purchaseHistoryByRangeSaga;